import { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS } from "../../helpers";

import Alert from "../../components/Alert";
import Notice from "../../components/Notice";
import Hdg from "../../components/Hdg";
import CheckboxUncontrolled from "../../components/CheckboxUncontrolled";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Nav from "../Nav";

const Bulk = () => {
	const [user, setUser] = useState({});
	const [details, setDetails] = useState({});
	const [names] = useState({});
	const [, setErrors] = useState([]);
	const [msg, setMsg] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const { id } = useParams();
	const history = useHistory();
	const formElement = useRef();

	useEffect(() => {
		const init = async () => {
			const token = getValFromLS("vtoUserToken")
				? getValFromLS("vtoUserToken")
				: "";
			const url = new URL(`${API_URL}/admin/hotelBulkInit`);
			const params = {
				token,
				id: id ? id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...json.user });

					setDetails({
						...json,
					});

					if (json.pending.length === 0) {
						setNotice({
							type: "error",
							text: "There are currently no pending requests available for bulk approval for this registration.",
						});
					}

					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/admin/hotelBulk`);
		let data = new FormData(formElement.current);
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("registrationId", details.registrationId);
		data.append("token", getValFromLS("vtoUserToken"));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/admin/hotel`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Hotel Management" admin={true} />
						<p>
							Use this form to perform bulk approvals on select pending requests
							for this registration. Note that only pending requests with
							sequential nights are available for bulk approval.
						</p>

						{notice.type && <Notice data={notice} />}

						<table
							className="approved assigned"
							style={{ marginTop: "15px", marginBottom: "15px" }}
						>
							<thead>
								<tr>
									<th className="center" style={{ width: "25%" }}>
										Registration ID
									</th>
									<th className="center" style={{ width: "75%" }}>
										Organization
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="center">{details.registrationId}</td>
									<td className="center">{details.organization}</td>
								</tr>
							</tbody>
						</table>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
							style={{ marginTop: "25px" }}
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Bulk Approve Pending Requests
							</h4>

							<div className="form-group one">
								<table
									className="approved bulk"
									style={{ marginTop: "7.5px", marginBottom: "15px" }}
								>
									<thead>
										<tr>
											<th className="center" style={{ width: "12.5%" }}>
												Approve
											</th>
											<th className="left">Request Details</th>
											<th className="center" style={{ width: "20%" }}>
												Hotel
											</th>
											<th className="center" style={{ width: "20%" }}>
												Arrive / Depart
											</th>
										</tr>
									</thead>
									<tbody>
										{details.pending.map((item) => {
											return (
												<tr key={item.id}>
													<td className="center">
														<CheckboxUncontrolled
															name="roomId[]"
															value={item.id}
															checked={false}
															disabled={false}
														/>
													</td>
													<td className="left">{item.details}</td>
													<td className="center">{item.hotel}</td>
													<td className="center">{item.dates}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/admin/hotel"
										left="Back"
										submit="Submit Bulk Approvals"
									/>
								</div>
							</div>

							<p style={{ marginTop: "20px", marginBottom: "0" }}>
								{details.lastUpdated}
							</p>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={0} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Bulk;
